import { BlockingModal } from 'components/BlockingModal/BlockingModal';
import React from 'react';
import { Content } from './EndGameModalStyles';

interface IProps {
  dismissCallback: () => void;
  endGameCallback: () => void;
}

const EndGameModal: React.FC<IProps> = (props) => {
  const { dismissCallback, endGameCallback } = props;

  return (
    <BlockingModal
      open
      onClose={dismissCallback}
      title='End this game?'
      cancelBtn={{
        label: 'Cancel',
        onClick: dismissCallback,
        width: '107px',
        style: {
          backgroundColor: '#F5F5F5',
          color: '#414141',
        },
      }}
      confirmBtn={{
        label: 'End game',
        onClick: endGameCallback,
        width: '121px',
        // @ts-ignore
        ['data-test']: 'end-game-modal-button',
      }}
      maxWidth='xs'
      fullWidth
    >
      <Content> A game cannot be resumed once it has been ended.</Content>
    </BlockingModal>
  );
};

export default EndGameModal;
